/** Single source of truth for "is this business white-label eligible": premium plan + a logo.
 *
 * Previously duplicated inline in `Storefront.jsx` and `StoreHero.jsx` (`business.plan ===
 * "premium" && !!business.logo_url`), while `Header.jsx`/`PortalShell.jsx` decided whether to
 * SHOW white-label chrome off the URL shape (`/b/:slug` vs plain `/:slug`) instead of off this
 * same eligibility check — so a premium branded business rendered full platform chrome on the
 * plain `/<city>/<slug>` URL it itself advertises as its own address (L2-002). One helper, reused
 * everywhere a "is this business white-label" decision is made.
 */
export function isWhiteLabelBusiness(business) {
  return Boolean(business && business.plan === "premium" && business.logo_url);
}

/** The in-app path a white-label business's own address/Share URL should point at (there is no
 * custom-domain field on the business model yet — see L2-002/fix_hint) — `/b/:slug`, which stays
 * white-labeled everywhere. A free/non-white-label business keeps the ordinary city path. */
export function advertisedBusinessPath(business) {
  return isWhiteLabelBusiness(business) ? `/b/${business.slug}` : `/${business.slug}`;
}

/** The address shown as a business's "Web address": the host the citizen is actually on (never the
 * API host or a mis-set `primary_domain` — RF-13 showed `.web.app/biswan/b/anand-sweets`) plus the
 * plain `/<city>/<slug>` path. `/b/` is an internal alias for the chromeless view, not a public URL. */
export function publicBusinessAddress(business, tenant) {
  const host = typeof window !== "undefined" ? window.location.host : "";
  return [host, tenant?.slug, business.slug].filter(Boolean).join("/");
}
